import React from 'react';
import ChefAvailabilityList from '../../chef/ChefAvailabilityList';
import { maskDayOfWeek } from '../../../masks';

const ChefAvailabilityNav = props => {
  const { subject: chef, isMobile = true } = props;
  const days = Array.from(Array(7).keys());
  const { chef_availabilities = [] } = chef;

  if (chef_availabilities.length === 0) return '';

  const list = days.map(day =>
    chef_availabilities.filter(a => a.day_of_week === day)
  );
  const mobileList = list
    .filter(l => l.length > 0)
    .map((d, i) => maskDayOfWeek(d[0].day_of_week).charAt(0))
    .join(',');

  return (
    <div className="on-boarding-nav-item__body">
      {!isMobile ? <ChefAvailabilityList list={list} /> : mobileList}
    </div>
  );
};

export default ChefAvailabilityNav;



// WEBPACK FOOTER //
// ./src/components/onboarding/chef/ChefAvailabilityNav.js